import * as React from "react"
import PropTypes from "prop-types"
import VimeoPlayer from "react-player/vimeo"

function LiteVimeoEmbed(props) {
  const [preconnected, setPreconnected] = React.useState(false)
  const videoTitle = props.title
  const announceWatch = props.announce || "Watch"
  const posterUrl = props.poster
  const aspectHeight = props.aspectHeight || 9
  const aspectWidth = props.aspectWidth || 16
  const activatedClassImp = props.activatedClass || "ltv-activated"
  const playerClassImp = props.playerClass || "ltv-playbtn"
  const wrapperClassImp = props.wrapperClass || "vimeo-lite"
  const onIframeAdded = props.onIframeAdded || function () {}
  const rel = props.rel ? "prefetch" : "preload"
  const ContainerElement = props.containerElement || "article"

  const warmConnections = () => {
    if (preconnected) return
    setPreconnected(true)
  }

  React.useEffect(() => {
    if (props.active) {
      setPreconnected(true)
      onIframeAdded()
    }
  }, [props.active])

  return (
    <>
      <link rel={rel} href={posterUrl} as="image" />
      <>
        {preconnected && (
          <>
            <link rel="preconnect" href="https://vimeo.com" />
          </>
        )}
      </>
      <ContainerElement
        onPointerOver={warmConnections}
        className={`${wrapperClassImp} ${
          props.active ? activatedClassImp : ""
        }`}
        onClick={props.active ? undefined : props.onActivate}
        data-title={videoTitle}
        style={{
          backgroundImage: `url(${posterUrl})`,
          ...{
            "--aspect-ratio": `${(aspectHeight / aspectWidth) * 100}%`,
          },
        }}>
        {!props.active && (
          <button
            type="button"
            className={playerClassImp}
            aria-label={`${announceWatch} ${videoTitle}`}
          />
        )}
        {props.active && (
          <VimeoPlayer
            key={props.playerKey}
            className="absolute inset-0 z-10"
            url={props.url}
            playsinline={true}
            muted={true}
            onReady={props.onReady}
            onStart={props.onStart}
            onPlay={props.onPlay}
            onPause={props.onPause}
            onEnded={props.onEnded}
            onDuration={props.onDuration}
            onProgress={props.onProgress}
            controls={true}
            playing={props.playing}
            width="100%"
            height="100%"
            onError={props.onError}
            config={{
              vimeo: {
                playerOptions: {
                  dnt: true,
                },
              },
            }}
          />
        )}
      </ContainerElement>
    </>
  )
}

LiteVimeoEmbed.propTypes = {
  active: PropTypes.bool.isRequired,
  activatedClass: PropTypes.string,
  announce: PropTypes.string,
  aspectHeight: PropTypes.number,
  aspectWidth: PropTypes.number,
  containerElement: PropTypes.elementType,
  onActivate: PropTypes.func.isRequired,
  onDuration: PropTypes.func.isRequired,
  onEnded: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onIframeAdded: PropTypes.func,
  onPause: PropTypes.func.isRequired,
  onPlay: PropTypes.func.isRequired,
  onProgress: PropTypes.func.isRequired,
  onReady: PropTypes.func.isRequired,
  onStart: PropTypes.func.isRequired,
  playerClass: PropTypes.string,
  playerKey: PropTypes.number.isRequired,
  playing: PropTypes.bool.isRequired,
  poster: PropTypes.string.isRequired,
  rel: PropTypes.bool,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  wrapperClass: PropTypes.string,
}

export default LiteVimeoEmbed
